import { PublicationService } from './../../../services/publication.service';
import { NgForm } from '@angular/forms';
import { Component, Input, SimpleChanges, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { Project } from '../../../interfaces/project';

@Component({
	selector: 'library-project-details-thumbnail',
	templateUrl: './library-project-details-thumbnail.component.html',
	styleUrls: ['./library-project-details-thumbnail.component.scss']
})


export class LibraryProjectDetailsThumbnailComponent implements OnInit, OnChanges {
	@Input() project: Project;
	@Input() form: NgForm;
	@Output() onThumbnailsChanged: EventEmitter<any[]> = new EventEmitter<any[]>();

	asset: string;

	constructor(publicationService: PublicationService) {
		this.asset = 'https://d3mxuwgars1eqe.cloudfront.net/media/2017/06/14/asset-1081219-1497451655638116.mp4?cb=1504775720212aa';
	}

	ngOnInit() {
		if (this.project && !this.project.thumbnails) {
			this.project.thumbnails = [];
		}
	}

	ngOnChanges(changesObj: SimpleChanges) {
		if (changesObj) { }
		for (const key in changesObj) {

			if (key === 'project') {
				const p = changesObj[key].currentValue;
				if (p && p.flowchart && p.flowchart.steps) {
					const newIds: string[] = [];
					if (p.mainMediaClipId) {
						// make sure the p.mainMediaClipId is the first one in the array
						newIds.push(p.mainMediaClipId);
					}
					Object.keys(p.flowchart.steps).forEach((id) => {
						const step = p.flowchart.steps[id];
						if (step && step.entityType === 'mediaclip' && step.entityId && step.entityId !== p.mainMediaClipId &&
						!newIds.includes(step.entityId)) {
							newIds.push(step.entityId);
						}
					});
				}
				if (p && !p.thumbnails) {
					p.thumbnails = [];
				}
			}
		}
	}

	thumbnailsChanged(thumbnails: any[]) {
		this.project.thumbnails = thumbnails;
		this.form.form.markAsDirty();
		this.onThumbnailsChanged.emit(thumbnails);
	}
}
